import type { NftSearchItem } from "@anaconda/core/nft/search/types"
import { useMemo } from "react"
import {
  type GridItem,
  GridItemType,
  type NftItem,
  type PlaceholderItem,
} from "./item"

const MAX_NFTS_PER_ROW = 7

const getPlaceholders = (count = MAX_NFTS_PER_ROW): PlaceholderItem[] =>
  Array.from({ length: count }).map(() => ({ type: GridItemType.PLACEHOLDER }))

const getNftItem = (nft: NftSearchItem): NftItem => ({
  type: GridItemType.NFT,
  nft,
})

export const useGridItems = (
  nfts: NftSearchItem[],
  loadingNextPage: boolean,
): GridItem[] => {
  const items = useMemo(() => nfts.map(getNftItem), [nfts])
  const placeholders = useMemo(
    () => (loadingNextPage ? getPlaceholders() : []),
    [loadingNextPage],
  )
  return useMemo(() => [...items, ...placeholders], [items, placeholders])
}
